<cls-header [isEuro]="isEuro" style="height: 70px"></cls-header>
<div class="wrapper"
    [@routerAnimations]="o &amp;&amp; o.activatedRouteData &amp;&amp; o.activatedRouteData['animation']"
    style="min-height: 100vh">
    <router-outlet #o="outlet"></router-outlet>
</div>